export default "__VITE_ASSET__QIwWmJrG__"